(function($) {

    $('.js-smooth-scroll').click(function(e){
        var target = this.getAttribute("href");
        $("html, body").animate({
        scrollTop: ($(target).offset().top) - 56
        }, 800);
    });

})(jQuery);  